/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DeploymentErrorCode,
  DeploymentErrorCode$inboundSchema,
} from "./deploymenterrorcode.js";

export type DeploymentError = {
  /**
   * The reason a deployment failed. `unknown` means Teral could not classify the
   *
   * @remarks
   * failure; see `message` for details.
   */
  code: DeploymentErrorCode;
  /**
   * The pipeline step that failed (e.g. `queued`, `building`, `deploying`).
   *
   * @remarks
   */
  step: string;
  /**
   * Human-readable description of why the deployment failed. For programmatic
   *
   * @remarks
   * handling, use `code`.
   */
  message: string;
};

/** @internal */
export const DeploymentError$inboundSchema: z.ZodType<
  DeploymentError,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: DeploymentErrorCode$inboundSchema,
  step: z.string(),
  message: z.string(),
});

export function deploymentErrorFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentError, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentError$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentError' from JSON`,
  );
}
